export const stepLabels: Record<string, string> = {
    document_conversion: 'Converting files',
    docx_parser: 'Reading Word document',
    party_detection: 'Detecting parties',
    outline_generation: 'Discovering table of contents',
    paragraphs_creation: 'Storing paragraphs',
    paragraphs_sections_creation: 'Storing table of contents',
    entity_predictions: 'Extracting values',
    frequency_analysis: 'Detecting familiarity',
};
